import { Box, Button, styled } from "@mui/material";

export const PageHeaderBox = styled(Box)`
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
`;
